import $ from 'jquery'
import Field from './../field'

const SectionBreak = (($) => {

	class SectionBreak extends Field {

		render(){
			let id = this.getForm().getID() + '_field_' + this._field.formFieldID

			this._element = document.createElement('section')
			this._element.classList.add('ion-form-group')
			this._element.classList.add('ion-form-group-break')

		// Label
			this._label = document.createElement('h3')
			this._label.htmlFor = id
			this._label.innerText = this._field.label
			this._element.appendChild(this._label)

		// Instructions
			let instructions = this.getSetting('instructions')
			if(instructions){
				let instructionBlock = document.createElement('div')
				instructionBlock.innerText = instructions
				this._element.appendChild(instructionBlock)
			}
		}

	}

	return SectionBreak
})($)

export default SectionBreak
